import UploadDocumentRequestModelBase from '../_generated/modelBases/upload-document-request-model-base';

export default class UploadDocumentRequestModel extends UploadDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
